<template>
 <div :class="windowClass">
        <v-row dense class="ma-2">
              <v-col cols="12" class="mb-4">
                  <v-card>
                      <v-toolbar dense dark color="secondary">
                          <v-icon left color="primary">mdi-dolly</v-icon> BORROWED
                          <v-spacer/>
                          <span style="width: 290px;">
                              <v-text-field
                                  v-model="search"
                                  append-icon="mdi-magnify"
                                  label="Search"
                                  solo
                                  dense
                                  hide-details
                              ></v-text-field>
                              </span>
                        </v-toolbar>
                        <v-data-table
                              class="va-table mt-2"
                              dense
                              :search="search"
                              :headers="headers"
                              disable-sort
                              :items="borroweds"
                              >
                              <template v-slot:body="{ items }">
                                  <tbody>
                                  <tr v-for="(item,index) in items" :key="index">
                                      <td>
                                         <v-icon left small color="success" @click="borrowed=item, borrowHistory=true">mdi-open-in-new</v-icon> 
                                        {{item.trade_name}}</td>
                                      <td class="borrowed_data">
                                         <div  v-for="(data, i) in item.borrowed_data" :key="item.customer_id +'-'+ i">
                                              <span>Code: {{data.product_code}}</span>
                                              <span>Borrowed: {{data.borrowed}}</span>
                                              <span>Returned: {{data.returned}}</span>
                                              <span>Returnable: {{data.returnable}}</span>
                                              <span>Value: {{$money($IsNum(data.unit_price) * $IsNum(data.returnable)) }}</span>
                                         </div> 

                                      </td>
                                  </tr>
                                  </tbody>
                              </template>
                          </v-data-table>
                  </v-card>
              </v-col>
              <v-col cols="12">
                     <v-card>
                     <v-toolbar dense dark color="secondary">
                          <v-icon left color="primary">mdi-door-closed-lock</v-icon> SAFE KEEP
                          <v-spacer/>
                          <span style="width: 290px;">
                              <v-text-field
                                  v-model="search2"
                                  append-icon="mdi-magnify"
                                  label="Search"
                                  solo
                                  dense
                                  hide-details
                              ></v-text-field>
                              </span>
                              <v-icon large right @click="form3=true">mdi-plus-box</v-icon>
                        </v-toolbar>
                        <v-data-table
                              class="va-table mt-2"
                              dense
                              :search="search2"
                              :headers="safe_headers"
                              :items="CUSTOMERKEEPS"
                              >
                              <template v-slot:body="{ items }">
                                  <tbody>
                                  <tr v-for="(item,index) in items" :key="index + 'k'">
                                      <td>
                                        <v-icon left small color="success" @click="keep=item, form2=true">mdi-open-in-new</v-icon> 
                                        {{item.trade_name}}</td>
                                      <td>{{item.quantity}}</td>
                                      <td>{{item.redeemed}}</td>
                                      <td :class="STATUS_TEXT(item.status)">{{item.status}}</td>
                                  </tr>
                                  </tbody>
                              </template>
                          </v-data-table>
                  </v-card>

              </v-col>
        </v-row>
        <!-- <va-borrowed-items :show="form1" :borrowed="borrowed" @DialogEvent="bEvent"/> -->
         <va-borrowed-view :show="borrowHistory" :borrowed="borrowed"  @DialogEvent="bEvent"/>
        <va-keep-items :show="form2" :keep="keep" @DialogEvent="bEvent"/>
        <va-select-user :show="form3" @DialogEvent="uEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      form1: false,
      form2: false,
      form3: false,
      keeps:[],
      keep:{},
      search:'',
      search2:'',
      borrowHistory: false,
      borrowed:{},
      borroweds: [],
      headers: [
          { text: 'TRADE NAME', value: 'trade_name' },
          { text: 'BORROWED', value: 'product_code' }
        ],
         safe_headers: [
          { text: 'CUSTOMER', value: 'trade_name' },
           { text: 'QTY', value: 'quantity' },
          { text: 'REDEEMED', value: 'redeemed' },
          { text: 'STATUS',  value: 'status' }
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.setLoggedIn(true) 
          this.getBorroweds()
           this.getKeeps()
           this.GET_CUSTOMERS('active')
           this. GET_PRODUCTS()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      CUSTOMERKEEPS() {
         var keepByTrade = this.$groupBy("trade_name")
         var entries = Object.entries(keepByTrade(this.keeps))
          var data = entries.reduce((res,item)=>{
            var quantity = item[1].reduce((o,i)=>o+=i.quantity,0)
            var redeemed = item[1].reduce((o,i)=>o+=i.redeemed,0)
              var param = {
                  trade_name: item[0],
                  quantity: quantity,
                  redeemed:redeemed,
                  customer:item[1][0].customer,
                  products:   item[1],
                  status: quantity == redeemed?'redeemed':'available'
                }
              res.push(param)
              return res
        },[])
        return data
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      bEvent(){
        this.form1 = false
        this.form2 = false
        this.borrowHistory = false
        this.getKeeps()
      },
      uEvent(data){
        if(data != "close") {
            this.keep =  {
                  trade_name: data.trade_name,
                  quantity: 0,
                  redeemed:0,
                  customer:this.$IsNum(data.id),
                  products:  []
                }
            this.form2 = true
        }
       
        this.form3 = false
      },
      getBorroweds() {
           this.$http.post("borrow/list", {Type:"Borrowed"}).then(response => {
              response.data.items !=null?this.borroweds = response.data.items : this.borroweds=[]
              console.log(this.borroweds)
              }).catch(e => {
              console.log(e.data)
          })
      },
      getKeeps() {
           this.$http.post("keep/list", {status:status}).then(response => {
                response.data.items !=null?this.keeps = response.data.items : this.keeps=[]
               }).catch(e => {
                console.log(e.data)
            })
      }
      
    },
  }
</script>